<template>
  <div class="border p-1 rounded-lg">
    <div class="mb-1 font-weight-bold">
      {{ $t('Security Options') }}
    </div>
    <b-row>
      <template v-if="type === 'basic'">
        <b-col sm="12" md="6">
          <b-form-group label-for="username" :label="$t('Username')">
            <validation-provider #default="{ errors }" :name="$t('Username')" rules="required">
              <b-form-input
                id="username"
                v-model="config.basic.username"
                name="username"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Username')"
                :tabindex="6"
                autocomplete="off"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
          <b-form-group label-for="password" :label="$t('Password')">
            <validation-provider #default="{ errors }" :name="$t('Password')" rules="required">
              <b-form-input
                id="password"
                v-model="config.basic.password"
                name="password"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Password')"
                :tabindex="6"
                autocomplete="off"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </template>
      <template v-if="type === 'bearer'">
        <b-col sm="12">
          <b-form-group label-for="tokenUrl" :label="$t('Token URL')">
            <validation-provider #default="{ errors }" :name="$t('Token URL')" rules="required|url">
              <b-form-input
                id="tokenUrl"
                v-model="config.bearer.tokenUrl"
                name="tokenUrl"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Token URL')"
                :tabindex="6"
                autocomplete="off"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
          <b-form-group label-for="username" :label="$t('Username')">
            <validation-provider #default="{ errors }" :name="$t('Username')" rules="required">
              <b-form-input
                id="username"
                v-model="config.bearer.data.username"
                name="username"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Username')"
                :tabindex="6"
                autocomplete="off"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
          <b-form-group label-for="password" :label="$t('Password')">
            <validation-provider #default="{ errors }" :name="$t('Password')" rules="required">
              <b-form-input
                id="password"
                v-model="config.bearer.data.password"
                name="password"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Password')"
                :tabindex="6"
                autocomplete="off"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
          <b-form-group label-for="tokenKey" :label="$t('Token Key')">
            <validation-provider #default="{ errors }" :name="$t('Token Key')" rules="required">
              <b-form-input
                id="tokenKey"
                v-model="config.bearer.tokenKey"
                name="tokenKey"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('Token Key')"
                :tabindex="6"
                autocomplete="off"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
          <b-form-group label-for="ttl" :label="$t('TTL')">
            <validation-provider #default="{ errors }" :name="$t('TTL')" rules="required">
              <b-form-input
                id="ttl"
                v-model="config.bearer.ttl"
                name="ttl"
                :state="errors.length > 0 ? false : null"
                :placeholder="$t('TTL')"
                :tabindex="6"
                type="number"
                autocomplete="off"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </template>
      <template v-if="type === 'header'">
        <b-col v-for="(_, index) in config.header" :key="index" sm="12">
          <b-row>
            <b-col>
              <b-form-group :label="$t('Key')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Key') + ' ' + (index + 1)"
                  rules="required"
                >
                  <b-form-input
                    v-model="config.header[index].headerKey"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('Key')"
                    :tabindex="6"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group :label="$t('Value')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Value') + ' ' + (index + 1)"
                  rules="required"
                >
                  <b-form-input
                    v-model="config.header[index].headerValue"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('Value')"
                    :tabindex="6"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              v-if="config.header.length > 1"
              sm="3"
              md="2"
              class="d-flex flex-column justify-content-end pb-1"
            >
              <b-button
                variant="outline-danger"
                class="w-full text-center"
                @click="config.header = config.header.filter((_, i) => i !== index)"
              >
                {{ $t('Delete') }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12">
          <b-button
            variant="outline-primary"
            class="w-full text-center"
            @click="
              config.header.push({
                headerKey: '',
                headerValue: ''
              })
            "
          >
            {{ $t('Add Row') }}
          </b-button>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { BButton, BCol, BFormInput, BRow, BFormGroup } from 'bootstrap-vue';

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormGroup,

    ValidationProvider
  },
  props: {
    type: {
      type: String,
      required: true
    },
    initialValues: {
      type: [Object, Array],
      default: null
    }
  },
  data() {
    return {
      config: {
        basic: {
          username: '',
          password: ''
        },
        header: [
          {
            headerKey: '',
            headerValue: ''
          }
        ],
        bearer: {
          tokenUrl: '',
          data: {
            username: '',
            password: ''
          },
          tokenKey: '',
          ttl: ''
        }
      }
    };
  },
  watch: {
    config: {
      handler() {
        this.emitValues();
      },
      deep: true,
      immediate: true
    },
    type() {
      this.emitValues();
    }
  },
  mounted() {
    if (this.config[this.type] && this.initialValues) {
      if (this.type === 'bearer' || this.type === 'basic') {
        this.config[this.type] = {
          ...this.config[this.type],
          ...JSON.parse(JSON.stringify(this.initialValues))
        };
      } else if (
        this.type === 'header' &&
        Array.isArray(this.initialValues) &&
        this.initialValues.length
      ) {
        this.config[this.type] = JSON.parse(JSON.stringify(this.initialValues));
      }
    }
  },
  methods: {
    emitValues() {
      if (this.config[this.type]) {
        this.$emit('change', this.config[this.type]);
      } else {
        this.$emit('change', null);
      }
    }
  }
};
</script>
